module.exports = __webpack_public_path__ + "static/media/bell.37314d8f.svg";